import React from "react";
import { Link, useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white px-5 flex items-center justify-center">
      <div className="text-center max-w-xl">
        <p className="text-darkBlue font-inter font-extrabold text-6xl md:text-7xl leading-none">
          404
        </p>
        <h1 className="font-inter text-2xl md:text-3xl font-semibold text-black mt-4">
          Page Not Found
        </h1>
        <p className="font-inter text-base text-foreground/80 mt-3">
          The page you are looking for doesn&#39;t exist.
        </p>
        <div className="flex flex-wrap gap-3 justify-center mt-7">
          <Link
            to="/"
            className="redButton inline-flex items-center justify-center"
          >
            Go Home
          </Link>
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="blueButton inline-flex items-center justify-center"
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
